import React, { useRef } from 'react'
import {DocumentDuplicateIcon, UploadIcon, XIcon} from '@heroicons/react/outline'
import { useRecoilState } from 'recoil';
import { contentInput } from '../../recoil/content';

const DocsInput = () => {
  const hiddenFileInput = useRef(null);
  const [input, setInput] = useRecoilState(contentInput);

  const addDocs = (docs) => {
    let newInput = {...input};
    newInput.documents = Object.assign([], newInput.documents);
    newInput.documents.push(...Array.from(docs));
    setInput(newInput);
  };

  const removeDoc = (i) => {
    let newInput = {...input};
    newInput.documents = Object.assign([], newInput.documents);
    newInput.documents.splice(i, 1);
    setInput(newInput);
  }

  const handleUpload = () => {
    hiddenFileInput.current.click();
  };

  const getDocURL = (file) => {
    const objectUrl = URL.createObjectURL(file);
    return objectUrl;
  }

  const loadDocs = () => {
    if (input.documents.length === 0) {
      return (
        <div className="flex items-center gap-1 italic cursor-default text-slate-500">
            <span>{"Upload (bisa lebih dari 1) dengan menekan icon "}</span>
            <UploadIcon className="w-5 h-5" />
        </div>
      );
    }
    return (
      <div className="flex flex-col gap-3">
          {
              input.documents.map((item, i) => (
                  <div key={i} className="flex items-center justify-between gap-3 px-3 py-2 rounded-lg hover:bg-slate-100">
                      <a href={getDocURL(item)} target="_blank" rel="noreferrer" title="Lihat Dokumen" className="flex-1 cursor-pointer overflow-clip hover:text-blue-600">{item.name}</a>
                      <XIcon className='w-5 h-5 cursor-pointer hover:text-red-500' onClick={() => removeDoc(i)} />
                  </div>
              ))
          }
      </div>
    );
  };


  return (
    <div className="flex flex-col items-start">
        <label htmlFor="document" className="text-sm">Dokumen <span className="text-xs text-red-500">{"(upload setidaknya 1 dokumen)"}</span></label>
        <div className="flex items-start w-full gap-5 px-5 py-3 mt-2 rounded-lg bg-slate-50">
            <DocumentDuplicateIcon className="w-6 h-6" />
            <div className="flex flex-col flex-1 gap-3">
                <span className="text-slate-500">Upload Dokumen berformat PDF {"(.pdf)"}</span>
                <input type="file" onChange={e => addDocs(e.target.files)} ref={hiddenFileInput} className="hidden" multiple accept="application/pdf" />
                {loadDocs()}
            </div>
            <UploadIcon onClick={handleUpload} className="w-6 h-6 cursor-pointer hover:text-blue-600" />
        </div>
    </div>
  )
}

export default DocsInput